export default "__VITE_ASSET__C3CNS9aT__"